export const removeLastSlashFromUrl = (url) => {
  if (!url || !url.length) {
    return '';
  }
  const lastIndex = url.length - 1;
  return url[lastIndex] === '/' ? url.slice(0, lastIndex) : url;
};

export default {};
